import { render, staticRenderFns } from "./DeveloperTabs.vue?vue&type=template&id=e3f68c86&scoped=true"
import script from "./DeveloperTabs.vue?vue&type=script&lang=js"
export * from "./DeveloperTabs.vue?vue&type=script&lang=js"
import style0 from "./DeveloperTabs.vue?vue&type=style&index=0&id=e3f68c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f68c86",
  null
  
)

export default component.exports